import React,{Component} from 'react';

import PaginatorSty from './Paginator.module.css';
import PropTypes from 'prop-types';

class Paginator extends Component{

    state={
        pageCount:Math.ceil(this.props.dataCount/this.props.pageSize), //总页数
        btnIndexList:[], //维护页按钮索引列表
        currentPage:1,
        seqBtnCount:this.props.maxBtnCount-2,//除去最后一个和...按钮，前面按顺序来的按钮数
    }

    static defaultProps={
        pageSize:10,
        dataCount:200,
        maxBtnCount:5,
    }

    constructor(props){
        super(props);
        this.getBtnIndexList=this.getBtnIndexList.bind(this);
        this.firstBtnOnClick=this.firstBtnOnClick.bind(this);
        this.lastBtnOnClick=this.lastBtnOnClick.bind(this);
        this.preBtnOnClick=this.preBtnOnClick.bind(this);
        this.nextBtnOnClick=this.nextBtnOnClick.bind(this);
    }

    componentWillMount=()=>{
        this.setState({
            btnIndexList:this.getBtnIndexList(this.state.currentPage),
        });
    }


    // 动态生成页数列表
    getBtnIndexList=(currentPage)=>{
 
        let tempIndexList=[];
        let pageCount=this.state.pageCount;

        // 第一种情况，总页数小于设定的最大页索引按钮数量，直接按顺序放入即可
        if(this.state.pageCount <= this.props.maxBtnCount){
            for(let i=0;i<=this.state.pageCount;i++)
                tempIndexList.push(i+1);
        }else{
            // 第二种情况，总页数大于设定的。
            //这种情况下，要考虑一下currentPage，即用户点到哪一页了。
            let index=currentPage;
            if(currentPage==this.state.pageCount){
                // 如果点击了最后一页的索引按钮
                for(let i=0;i<this.props.maxBtnCount && index >0;i++,index--)
                    tempIndexList.push(index);
                tempIndexList.reverse();
            }else{
                for(let i=0;i<this.state.seqBtnCount && index<=this.state.pageCount;i++,index++){
                    tempIndexList.push(index);
                }
    
                if (index<this.state.pageCount-1){
                    tempIndexList.push('...');
                    tempIndexList.push(this.state.pageCount);
                }else{
                    tempIndexList.push(index);
                    tempIndexList.push(index+1);
                }
            }
            
        }
        
        return tempIndexList;
    }

    // 按钮选页响应事件
    onSelectPageClick=(currentPage)=>{
        console.log('当前页是:'+currentPage);
        let isUpdateBtnList=false;
        this.props.onSelectPageClick(); //调用父组件的监听事件进行响应。

        //对于onSelectPageClick这个事件来说，我让它只有点击...的时候才更新按钮索引列表。
        //而不是让用户点一下，就更新一下。
        if(currentPage === '...'){
            currentPage=this.state.btnIndexList[this.state.seqBtnCount-1]+1;
            isUpdateBtnList=true;
        }
        if (currentPage===this.state.pageCount)
            isUpdateBtnList=true;

        if(isUpdateBtnList){
            //更新按钮索引列表
            this.setState({
                currentPage:currentPage,
                btnIndexList:this.getBtnIndexList(currentPage), //更新按钮索引页列表
            });
        }else{
            this.setState({
                currentPage:currentPage,
            });
        }

        this.props.parent.updateCurrentPage(currentPage);

    }

    firstBtnOnClick=()=>{
        this.props.firstBtnOnClick();
        this.setState({
            currentPage:1,
            btnIndexList:this.getBtnIndexList(1),
        });

        this.props.parent.updateCurrentPage(1);
    }

    lastBtnOnClick=()=>{
        this.props.lastBtnOnClick();
        this.setState({
            currentPage:this.state.pageCount,
            btnIndexList:this.getBtnIndexList(this.state.pageCount)
        });

        this.props.parent.updateCurrentPage(this.state.pageCount);
       
    }

    preBtnOnClick=()=>{
        this.props.preBtnOnClick();
        let currentPage=this.state.currentPage == 1 ? 1:this.state.currentPage-1;
        //如果当前页索引加上最大显示按钮数无法全部展示出，就更新列表。
        if (currentPage+this.props.maxBtnCount<=this.state.pageCount){
            this.setState({
                currentPage:currentPage,
                btnIndexList:this.getBtnIndexList(currentPage),
            });
        }else{
            this.setState({
                currentPage:currentPage,
            });
        }

        this.props.parent.updateCurrentPage(currentPage);
        
    }

    nextBtnOnClick=()=>{
        this.props.nextBtnOnClick();
        let currentPage=this.state.currentPage==this.state.pageCount? this.state.pageCount:this.state.currentPage+1;
        //如果当前页加上最大显示按钮数无法全部索引展示出，就更新列表。否则，只更新当前页
        if(currentPage+this.props.maxBtnCount<this.state.pageCount+2){
            this.setState({
                currentPage:currentPage,
                btnIndexList:this.getBtnIndexList(currentPage),
            });
        }else{
            this.setState({
                currentPage:currentPage,
            });
        }

        this.props.parent.updateCurrentPage(currentPage);
        
    }

    componentDidUpdate=()=>{
        console.log('组件更新');
        // 通过父组件的回调接口，将值传递给父组件
        // this.props.parent.updateCurrentPage(this.state.currentPage);
        

    }




    render(){
        console.log('分页器组件查看state')
        console.log(this.state);

        let btnIndexLis=this.state.btnIndexList.map((item)=>{
            let btnSelectSty={
                backgroundColor:'#181818',
                color:'#FFFFFF'
            }
            let btnNormalSty={
                backgroundColor:'#EEEEEE',
                color:'#333333'
            }
            return(
                <li>
                    <div onClick={()=>{this.onSelectPageClick(item)}} style={this.state.currentPage==item? btnSelectSty:btnNormalSty}>{item}</div>
                </li>
            );
        });

        return(
            <div className={this.props.className}>
                <div className={PaginatorSty.titleDiv}>
                    <div className={PaginatorSty.titleSty}>{this.props.title}</div>
                </div>

                {this.props.children}

                <div className={PaginatorSty.paginatorBtnDiv}>
                    <div className={PaginatorSty.fixedBtnSty} onClick={()=>{this.firstBtnOnClick()}}>首页</div>
                    <div className={PaginatorSty.fixedBtnSty} onClick={()=>{this.preBtnOnClick()}}>上一页</div>
                    <ul>
                        {btnIndexLis}
                    </ul>
                    <div className={PaginatorSty.fixedBtnSty} onClick={()=>{this.nextBtnOnClick()}}>下一页</div>
                    <div className={PaginatorSty.fixedBtnSty} onClick={()=>{this.lastBtnOnClick()}}>尾页</div>
                </div>
            </div>
        );
    }
}


Paginator.propTypes={
    className:PropTypes.string,
    title:PropTypes.string.isRequired,
    pageSize:PropTypes.number.isRequired, // 每页显示多少行
    currentPage:PropTypes.number.isRequired,  //当前页索引
    dataCount:PropTypes.number.isRequired,    //数据总条数
    maxBtnCount:PropTypes.number.isRequired,  //最多显示按钮数
    firstBtnOnClick:PropTypes.func.isRequired,   //首页 按钮的监听事件
    lastBtnOnClick:PropTypes.func.isRequired,  //尾页 按钮的监听事件
    preBtnOnClick:PropTypes.func.isRequired,  //上一页 按钮的监听事件 
    nextBtnOnClick:PropTypes.func.isRequired,  //下一页按钮的监听事件
    onSelectPageClick:PropTypes.func.isRequired, //选页按钮的监听事件
    parent:PropTypes.object.isRequired,
}

export default Paginator;